import { getFeature } from 'Cloud/Application/FeaturesEs6';

const outflowManyOffersAB: 'a' | 'b' | false = getFeature('outflow-many-offers-ab');

const outflowOffersMinHighSpace = getFeature('outflow-offers-min-high-space') || 256 * 1024 * 1024 * 1024;

const outflowOffersMinHighPayments = getFeature('outflow-offers-min-high-payments') || 2;

export const outflowManyOffers = {
    enabled: outflowManyOffersAB === 'b',
    outflowOffersMinHighSpace,
    outflowOffersMinHighPayments,
} as const;
